import "./NotFound.scss"
const NotFound = () => {
  return (
    <div className="notfound">
      <img src="/images/notfound.webp" alt="notfound" />
    </div>
  )
}

export default NotFound
